/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/location';
import '../resources/card_holder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "AddressType": {
                "values": {
                  "BILLING": 1,
                  "SHIPPING": 2
                }
              },
              "UpdateAddressRequest": {
                "fields": {
                  "cardHolderToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "address": {
                    "type": ".squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  },
                  "type": {
                    "type": ".squareup.corporate_card.service.AddressType",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "UpdateAddressResponse": {
                "fields": {
                  "cardHolder": {
                    "type": ".squareup.corporate_card.resources.CardHolder",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.AddressType && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateAddressRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.UpdateAddressResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE AddressType @ squareup/corporate_card/service/update_address.proto at 12:1
 */
export const AddressType = $root.lookupEnum('squareup.corporate_card.service.AddressType').values;
/**
 * SOURCE UpdateAddressRequest @ squareup/corporate_card/service/update_address.proto at 24:1
 */
export const UpdateAddressRequest = $root.lookupType('squareup.corporate_card.service.UpdateAddressRequest');
fixType(UpdateAddressRequest, {
  cardHolderToken: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateAddressRequest);
/**
 * SOURCE UpdateAddressResponse @ squareup/corporate_card/service/update_address.proto at 44:1
 */
export const UpdateAddressResponse = $root.lookupType('squareup.corporate_card.service.UpdateAddressResponse');
fixType(UpdateAddressResponse);
Builder.createAndAttachToType(UpdateAddressResponse);